import React, { useEffect, useState } from "react";
import FHIR from "fhirclient";
import { useParams } from "react-router-dom";
import {
  Anchor,
  Box,
  Button,
  Flex,
  Grid,
  Group,
  Image,
  Modal,
  MultiSelect,
  Select,
  Tabs,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import Layout from "./Layout";
import {
  HealthConnectApps,
  homeCareRequest,
  hospitalNames,
  intialFormData,
  logisticRequest,
  referralSections,
  specialties,
  transportRequest,
} from "./Constant";
import { PatientDetails } from "../questionnare/Card";
import { getPatientName } from "../Eligibility/EligibiltyService";
import { showNotification } from "@mantine/notifications";
import { useMedplum } from "@medplum/react";
import { DateTimePicker } from "@mantine/dates";
import locationGif from "../../assets/img/locatioPin.gif";
import {
  IconCalendar,
  IconCar,
  IconHome,
  IconMail,
  IconProgressCheck,
  IconTools,
  IconWorld,
} from "@tabler/icons-react";
import BorderFrame from "./Border";
import Footer from "./EmbedFooter";
import { extractNoteTexts } from "./Service";
import { SummaryCard } from "./SummaryLogistics";

interface logisticsProps {
  aiName?: string;
}

const Logistics: React.FC<logisticsProps> = ({ aiName }) => {
  const { code } = useParams();
  const medplum = useMedplum();
  const [showBorder, setShowBorder] = useState<boolean>(false);
  const [isConnecting, setIsConnecting] = useState(true);
  const [conditions, setConditions] = useState<any>([]);
  const [selectedSymptom, setSelectedSymptoms] = useState<string | undefined>();

  const [patient, setPatient] = useState<any>();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedCard, setSelectedCard] = useState("Patient Logistic Request");
  const [formData, setFormData] = useState<any>(intialFormData);

  useEffect(() => {
    fetchData();
    loginWithIdandSecret();
  }, []);
  useEffect(() => {
    // Show the "please wait" message for 3 seconds
    if (showModal) {
      setIsConnecting(true); // Reset to show the GIF when modal opens
      const timer = setTimeout(() => {
        setIsConnecting(false); // Switch to the success message after 3 seconds
      }, 5000);

      // Cleanup the timer when modal is closed or component unmounts
      return () => clearTimeout(timer);
    }
  }, [showModal]);

  const handleCheckboxChange = (isChecked: any) => {
    setShowBorder(isChecked);
  };
  const handleChange = (event: any) => {
    console.log(event.target.value, "e");
    console.log(formData);

    const { name, value } = event.target || event; // Use event directly if event.target is not available
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };
  const loginWithIdandSecret = async () => {
    try {
      const decodedQuery = decodeURIComponent(code as string);

      const decodeQueryStringWithData = atob(decodedQuery);

      const queryParamss = decodeQueryStringWithData.split(",");
      //   setClientData(queryParamss);
      const id = queryParamss[0];
      const secret = queryParamss[1];

      const login = await medplum.startClientLogin(id, secret);
      if (login) {
        return true;
      }
    } catch (error) {
      console.error(error);
    }
  };
  const fetchData = async () => {
    try {
      const client = await FHIR.oauth2.ready();

      // Get the patient data
      const patientData = await client.patient.read<any>();
      setPatient(patientData);
      const conditionsResponse = await client.request<{ entry: any }>(
        `Condition?patient=${client.patient.id}&_count=20`
      );
      const symptoms = extractNoteTexts(conditionsResponse.entry);
      setFormData((prevState: any) => ({
        ...prevState,
        medicalConditions: symptoms,
      }));
      setSelectedSymptoms(symptoms);

      setConditions(conditionsResponse.entry || []);
    } catch (error) {
      console.error(error);
      showNotification({
        color: "red",
        message: `Error Fetching data: ${error}`,
        autoClose: true,
      });
    }
  };

  const handleSubmit = () => {
    let allFieldsFilled = true;

    if (selectedCard === "Patient Logistic Request") {
      const transportFields = [
        formData.Pickup,
        formData.Destination,
        formData.dateTime,
        formData.transportType,
        formData.medicalConditions,

        formData.contactInfo,
        formData.transportUrgency,
      ];
      allFieldsFilled = transportFields.every((field) => field !== "");
    } else if (selectedCard === "Home Care Request") {
      const homeCareFields = [
        formData.homeCareType,
        formData.requestedDate,
        formData.careDuration,
        formData.caregiverPreferences,
        formData.medicalConditions,
        formData.equipmentNeeded,
      ];
      allFieldsFilled = homeCareFields.every((field) => field !== "");
    } else if (selectedCard === "Medical Delivery Request") {
         setFormData((prevState: any) => ({
           ...prevState,
           medicalConditions: "",
         }));
      const equipmentFields = [
        formData.equipmentType,
        formData.deliveryAddress,
        formData.deliveryDate,
        formData.installationNeeds,
        formData.contactCoordination,
        formData.rentalInformation,
      ];
      allFieldsFilled = equipmentFields.every((field) => field !== "");
    }

    if (allFieldsFilled) {
      setShowModal(true);

      // Handle form submission
    } else {
      // Show a notification or alert that fields are missing
      showNotification({
        color: "red",
        message: `Please fill all fields`,
        autoClose: true,
      });
    }
  };
  return (
    <BorderFrame showBorder={showBorder}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          backgroundColor: "#F8F8F8",
          height: showBorder ? "calc(100vh - 75px)" : "calc(100vh - 75px)", // Adjusted height
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            height: showBorder
              ? "calc(100vh - 80px)"
              : "aucalc(100vh - 75px)to",
          }}
        >
          <Box>
            <Layout
              showBorderFunction={handleCheckboxChange}
              title={selectedCard}
              data={
                selectedCard === "Patient Logistic Request"
                  ? transportRequest
                  : selectedCard === "Home Care Request"
                  ? homeCareRequest
                  : selectedCard === "Medical Delivery Request"
                  ? logisticRequest
                  : ""
              }
              info={
                selectedCard === "Patient Logistic Request"
                  ? HealthConnectApps.LOGISTICS_TRANSPORT.description
                  : selectedCard === "Home Care Request"
                  ? HealthConnectApps.LOGISTIC_HOME_CARE.description
                  : selectedCard === "Medical Delivery Request"
                  ? HealthConnectApps.LOGISTICS_EQUIPMENT_DELIVERY.description
                  : ""
              }
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              padding: "8px",

              height: showBorder ? "calc(100vh - 75px)" : "calc(100vh - 140px)", 
            }}
          >
            <Box sx={{ backgroundColor: "white", borderRadius: "8px" }}>
              <PatientDetails
                name={getPatientName(patient?.name)}
                dob={patient?.birthDate ?? "--"}
                mobile={patient?.telecom?.[0]?.value}
                address={"--"}
                email={patient?.email ?? "--"}
                gender={patient?.gender ?? "--"}
                moreDetails={true}
                city={patient?.address?.[0]?.city}
                country={patient?.address?.[0]?.country}
                age={
                  patient?.birthDate
                    ? new Date().getFullYear() -
                      new Date(patient.birthDate).getFullYear() -
                      (new Date().setFullYear(0) <
                      new Date(patient.birthDate).setFullYear(0)
                        ? 1
                        : 0)
                    : "--"
                }
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                maxHeight: "90vh",
                overflowY: "auto",
                scrollBehavior: "smooth",
                "&::-webkit-scrollbar": {
                  width: "1px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: "#555",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
              }}
            >
              <Tabs
                defaultValue="Patient Logistic Request"
                onTabChange={(e) => {
                  setSelectedCard(e as any);
                  console.log(e, "e");
                }}
              >
                <Tabs.List>
                  <Tabs.Tab
                    value="Patient Logistic Request"
                    icon={
                      <IconCar
                        color={
                          selectedCard === "Patient Logistic Request"
                            ? "#228be6"
                            : "black"
                        }
                      />
                    }
                  >
                    <Text
                      sx={(theme) => ({
                        color:
                          selectedCard === "Patient Logistic Request"
                            ? "#228be6"
                            : theme.colors.gray[7],
                      })}
                      fw={500}
                    >
                      Patient Logistic Request
                    </Text>
                  </Tabs.Tab>
                  <Tabs.Tab
                    value="Home Care Request"
                    icon={
                      <IconHome
                        color={
                          selectedCard === "Home Care Request"
                            ? "#228be6"
                            : "black"
                        }
                      />
                    }
                  >
                    <Text
                      sx={(theme) => ({
                        color:
                          selectedCard === "Home Care Request"
                            ? theme.colors.blue[6]
                            : theme.colors.gray[7],
                      })}
                    >
                      Home Care Request
                    </Text>
                  </Tabs.Tab>
                  <Tabs.Tab
                    value="Medical Delivery Request"
                    icon={
                      <IconTools
                        color={
                          selectedCard === "Medical Delivery Request"
                            ? "#228be6"
                            : "black"
                        }
                      />
                    }
                  >
                    <Text
                      sx={(theme) => ({
                        color:
                          selectedCard === "Medical Delivery Request"
                            ? theme.colors.blue[6]
                            : theme.colors.gray[7],
                      })}
                    >
                      Medical Delivery Request
                    </Text>
                  </Tabs.Tab>
                </Tabs.List>

                <Box
                  sx={{
                    overflowY: "auto",
                    maxHeight: showBorder ? "100vh" : "65vh",
                    scrollBehavior: "smooth",
                    "&::-webkit-scrollbar": {
                      width: "1px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#888",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      backgroundColor: "#555",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f1f1f1",
                    },
                  }}
                >
                  <Box>
                    {/* Referral Information Section */}
                    <Box
                      sx={{
                        borderRadius: "8px",
                        backgroundColor: "white",
                        padding: "12px",
                      }}
                    >
                      <Title order={1} mb={"18px"} mt={"sm"}>
                        Please fill the form to raise a request
                      </Title>

                      {selectedCard === "Patient Logistic Request" && (
                        <Tabs.Panel value="Patient Logistic Request">
                          <Grid>
                            <Grid.Col span={6}>
                              <TextInput
                                name="Pickup"
                                label="Pick up"
                                placeholder="Enter Address"
                                value={formData.Pickup}
                                onChange={handleChange}
                              />
                            </Grid.Col>
                            <Grid.Col span={6}>
                              <TextInput
                                name="Destination"
                                label="Destination"
                                placeholder="Enter Address"
                                value={formData.Dropoff}
                                onChange={handleChange}
                              />
                            </Grid.Col>
                            <Grid.Col span={12}>
                              <DateTimePicker
                                name="requestedFor"
                                label="Requested for"
                                placeholder="Select Date and Time"
                                value={formData.dateTime}
                                onChange={(date) =>
                                  setFormData({
                                    ...formData,
                                    dateTime: date as any,
                                  })
                                }
                              />
                            </Grid.Col>
                            <Grid.Col span={6}>
                              <Select
                                name="servicetype"
                                placeholder="Select service"
                                label="Service"
                                data={[
                                  { value: "ambulance", label: "Ambulance" },
                                  {
                                    value: "wheelchair",
                                    label: "Wheelchair Van",
                                  },
                                  {
                                    value: "Gurney",
                                    label: "Gurney",
                                  },
                                ]}
                                value={formData.transportType}
                                onChange={(value) =>
                                  setFormData({
                                    ...formData,
                                    transportType: value ?? "",
                                  })
                                }
                              />
                            </Grid.Col>
                            <Grid.Col span={6}>
                              <Select
                                name="transportType"
                                placeholder="Select service type"
                                label="Service type"
                                data={[
                                  {
                                    value: "Urgent Transportation",
                                    label: "Urgent Transportation",
                                  },
                                  {
                                    value: "Urgent Transportation",
                                    label: "Non Urgent Transportation",
                                  },
                                ]}
                                value={formData.transportUrgency}
                                onChange={(value) =>
                                  setFormData({
                                    ...formData,
                                    transportUrgency: value ?? "",
                                  })
                                }
                              />
                            </Grid.Col>

                            <Grid.Col span={12}>
                              <TextInput
                                name="medicalConditions"
                                label="Patient's Medical Conditions/Special Instructions"
                                placeholder="Enter any instructions"
                                value={formData.medicalConditions}
                                onChange={handleChange}
                              />
                            </Grid.Col>
                            <Grid.Col span={12}>
                              <TextInput
                                name="contactInfo"
                                label="Additional Information"
                                placeholder=" Enter additional information"
                                value={formData.contactInfo}
                                onChange={handleChange}
                              />
                            </Grid.Col>
                          </Grid>
                        </Tabs.Panel>
                      )}

                      {selectedCard === "Home Care Request" && (
                        <Tabs.Panel value="Home Care Request">
                          <Grid>
                            <Grid.Col span={12}>
                              <Select
                                placeholder="Select type of home care"
                                name="homeCareType"
                                label="Type of Home Care"
                                data={[
                                  { value: "nursing", label: "Nursing" },
                                  {
                                    value: "physiotherapy",
                                    label: "Physiotherapy",
                                  },
                                  {
                                    value: "medication",
                                    label: "Medication administration",
                                  },
                                ]}
                                value={formData.homeCareType}
                                onChange={(value) =>
                                  setFormData({
                                    ...formData,
                                    homeCareType: value ?? "",
                                  })
                                }
                              />
                            </Grid.Col>
                            <Grid.Col span={6}>
                              <DateTimePicker
                                name="requestedDate"
                                label="Requested for"
                                placeholder="Select Date and Time"
                                value={formData.requestedDate}
                                onChange={(date) =>
                                  setFormData({
                                    ...formData,
                                    requestedDate: date as any,
                                  })
                                }
                              />
                            </Grid.Col>
                            <Grid.Col span={6}>
                              <TextInput
                                name="careDuration"
                                label="Duration of Care"
                                placeholder="Enter duration"
                                value={formData.careDuration}
                                onChange={handleChange}
                              />
                            </Grid.Col>
                            <Grid.Col span={12}>
                              <TextInput
                                name="caregiverPreferences"
                                label="Caregiver Preferences"
                                placeholder="Skills, Language"
                                value={formData.caregiverPreferences}
                                onChange={handleChange}
                              />
                            </Grid.Col>
                            <Grid.Col span={12}>
                              <TextInput
                                name="medicalConditions"
                                label="Patient's Medical Conditions/Special Instructions"
                                placeholder="Enter any instructions"
                                value={formData.medicalConditions}
                                onChange={handleChange}
                              />
                            </Grid.Col>
                            <Grid.Col span={12}>
                              <TextInput
                                name="equipmentNeeded"
                                label="Equipment or Supplies Needed"
                                placeholder="e.g., IV, Oxygen"
                                value={formData.equipmentNeeded}
                                onChange={handleChange}
                              />
                            </Grid.Col>
                          </Grid>
                        </Tabs.Panel>
                      )}

                      {selectedCard === "Medical Delivery Request" && (
                        <Tabs.Panel value="Medical Delivery Request">
                          <Grid>
                            <Grid.Col span={6}>
                              <Select
                                placeholder="Select equipment type"
                                name="equipmentType"
                                label="Equipment Type"
                                data={[
                                  { value: "oxygenTank", label: "Oxygen Tank" },
                                  {
                                    value: "hospitalBed",
                                    label: "Hospital Bed",
                                  },
                                  { value: "cpap", label: "CPAP Machine" },
                                ]}
                                value={formData.equipmentType}
                                onChange={(value) =>
                                  setFormData({
                                    ...formData,
                                    equipmentType: value ?? "",
                                  })
                                }
                              />
                            </Grid.Col>
                            <Grid.Col span={6}>
                              <TextInput
                                name="installationNeeds"
                                label="Installation Needs"
                                placeholder="Technician setup, if applicable"
                                value={formData.installationNeeds}
                                onChange={handleChange}
                              />
                            </Grid.Col>
                            <Grid.Col span={12}>
                              <TextInput
                                name="deliveryAddress"
                                label="Delivery Address"
                                placeholder="Enter Address"
                                value={formData.deliveryAddress}
                                onChange={handleChange}
                              />
                            </Grid.Col>
                            <Grid.Col span={12}>
                              <DateTimePicker
                                name="deliveryDate"
                                label="Requested for"
                                placeholder="Select Date and Time"
                                value={formData.deliveryDate}
                                onChange={(date) =>
                                  setFormData({
                                    ...formData,
                                    deliveryDate: date as any,
                                  })
                                }
                              />
                            </Grid.Col>

                            <Grid.Col span={12}>
                              <TextInput
                                name="contactCoordination"
                                label="Additional information for Delivery Coordination"
                                placeholder="Enter additional info"
                                value={formData.contactCoordination}
                                onChange={handleChange}
                              />
                            </Grid.Col>
                            <Grid.Col span={12}>
                              <TextInput
                                name="rentalInformation"
                                label="Duration or Rental Information"
                                placeholder="Rental information"
                                value={formData.rentalInformation}
                                onChange={handleChange}
                              />
                            </Grid.Col>
                          </Grid>
                        </Tabs.Panel>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Tabs>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  padding: "8px",
                }}
              >
                <Button onClick={handleSubmit}>Submit</Button>
              </Box>
            </Box>
          </Box>
        </Box>

        <Footer />
        {showModal && (
          <Modal
            opened={showModal}
            onClose={() => setShowModal(false)}
            size={"lg"}
            withCloseButton={false}
            centered
            closeOnClickOutside={false}
            closeOnEscape={false}
          >
            <Flex
              mih={250}
              justify="center"
              align="center"
              direction="column"
              gap="20px"
            >
              {isConnecting ? (
                <>
                  <Box w={"250px"}>
                    {" "}
                    <Image src={locationGif} />
                  </Box>
                  <Title fw={600} lh="30px" size="lg">
                    Please wait, we are sending the request to the Logistics
                    Provider...
                  </Title>
                </>
              ) : (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {/* <IconProgressCheck size="60px" color="green" /> */}
                  </Box>
                  {/* <Title fw={600} lh="30px" size="lg">
                    {selectedCard} request has been sent successfully
                  </Title> */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      gap: "12px",
                    }}
                  >
                    <SummaryCard
                      serviceLevel="Gurney"
                      requestedBy={getPatientName(patient?.name)}
                      status="Pending"
                      serviceType={selectedCard}
                      formData={formData}
                    />
                    <Button
                      onClick={() => {
                        setFormData(intialFormData);
                        setFormData((prevState: any) => ({
                          ...prevState,
                          medicalConditions: selectedSymptom,
                        }));
                        setShowModal(false);
                      }}
                    >
                      Raise Another Request
                    </Button>
                  </Box>
                </>
              )}
            </Flex>
          </Modal>
        )}
      </Box>
    </BorderFrame>
  );
};

export default Logistics;
